import { Button, Icon } from '@workramp/ui';
import { useTheme } from 'styled-components';
import Urls from '~/urls';
import { getAcademiesViewUrl } from '~/clc/features/academies/utils';

const {
  APP_CONSTANTS: { ASSET_PICKER_TYPES },
} = window;

export type ContentTypes = typeof ASSET_PICKER_TYPES.GUIDE | typeof ASSET_PICKER_TYPES.RESOURCE;

interface SourceItemProps {
  id: string;
  title: string;
  contentType: ContentTypes;
  isAcademy?: boolean;
}

function getUrl({ id, contentType, isAcademy }: Omit<SourceItemProps, 'title'>) {
  if (isAcademy) {
    return getAcademiesViewUrl({
      id,
      type: contentType,
      contentId: id,
      contentType,
    });
  }

  return contentType === ASSET_PICKER_TYPES.GUIDE ? Urls.guideStart(id) : Urls.resourcePreview(id, null);
}

export const SourceItem = ({ id, title, contentType, isAcademy }: SourceItemProps) => {
  const theme = useTheme();

  const iconName = contentType === ASSET_PICKER_TYPES.GUIDE ? 'guide:regular' : 'resource:regular';
  const iconColor =
    contentType === ASSET_PICKER_TYPES.GUIDE ? theme.colors.decorative.blue[500] : theme.colors.decorative.teal[500];

  const href = getUrl({ id, contentType, isAcademy });

  return (
    <Button
      variant="outline"
      color="secondary"
      leadingIcon={<Icon name={iconName} color={iconColor} />}
      href={href}
      rel="noreferrer"
      target="_blank"
    >
      {title}
    </Button>
  );
};
